import React from 'react';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { Gallery, Item } from 'react-photoswipe-gallery';
import 'photoswipe/dist/photoswipe.css';
import { motion } from "framer-motion";
import ReactDOMServer from 'react-dom/server';
import ImageSchema from './Shared/ImageSchema';
export default function StripImageCarousel(props) {
    var fields = props.fields, children = props.children;
    var TitleTag = (fields.preTitleTag || 'h4');
    var getCaptionText = function (item) {
        var cardContent = React.createElement(React.Fragment, null,
            item.fields.title &&
                React.createElement("h3", { className: "h2 caption-title" }, item.fields.title),
            item.fields.content &&
                React.createElement("div", { className: "caption-card-body d-flex align-items-end" },
                    React.createElement("div", { className: "caption-card-text flex-grow-1", dangerouslySetInnerHTML: { __html: item.fields.content } })));
        return cardContent;
    };
    function getQueryStringParameter(url, parameter) {
        var queryStringStartIndex = url.indexOf('?');
        if (queryStringStartIndex !== -1) {
            var queryString = url.substring(queryStringStartIndex + 1);
            var params = queryString.split('&');
            for (var i = 0; i < params.length; i++) {
                var param = params[i].split('=');
                var paramName = decodeURIComponent(param[0]);
                if (paramName === parameter) {
                    return decodeURIComponent(param[1]);
                }
            }
        }
        return null;
    }
    return (React.createElement(motion.div, { initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-30%" }, className: "strip sky23-image-carousel splide container-fluid"
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "") },
        React.createElement("div", { className: "row title-image-carousel" }, fields.displayTitle &&
            React.createElement(TitleTag, { className: "title " + fields.titleStyle, itemProp: "name", dangerouslySetInnerHTML: { __html: fields.displayTitle } }) || null),
        React.createElement(Splide, { "aria-label": "My Favorite Images", className: "left-nav", hasTrack: false, options: {
                rewind: true,
                focus: 0,
                //width: '480',
                gap: '1rem',
                pagination: false,
                perMove: 3,
                perpage: 3,
                breakpoints: {
                    1024: {
                        perMove: 3,
                        perpage: 3,
                    },
                    767: {
                        perMove: 2,
                        perpage: 2,
                    },
                    640: {
                        perMove: 1,
                        perpage: 1,
                    },
                },
                wheel: false,
            } },
            React.createElement("div", { className: "row g-0 featured-items-carousel-wrapper" },
                React.createElement("div", { className: "col featured-carousel-caption-col d-flex flex-column align-items-start" },
                    React.createElement("div", { className: "splide__arrows slider-nav" },
                        React.createElement("button", { type: "button", className: "slider-nav-prev bg-moss splide__arrow splide__arrow--prev btn-with-icon arrow arrow-left text-primary single-icon me-3", "aria-label": "Previous" }),
                        React.createElement("button", { type: "button", className: "slider-nav-next bg-moss splide__arrow splide__arrow--next btn-with-icon arrow arrow-right text-primary single-icon", "aria-label": "Next" }))),
                React.createElement("div", { className: "col featured-carousel-items-col text-stone", itemScope: true, itemType: "https://schema.org/ItemList" },
                    React.createElement(SplideTrack, null,
                        React.createElement(Gallery, { options: { initialZoomLevel: 'fit', secondaryZoomLevel: 2.5 }, withCaption: true }, children && children.length > 0 && children.map(function (item, j) {
                            return (React.createElement(SplideSlide, { key: j, itemProp: "itemListElement", itemScope: true, itemType: "https://schema.org/Place" },
                                React.createElement("div", { className: "splide-card justify-content-between p-4 border-radius d-flex flex-column" },
                                    item.fields.image &&
                                        ImageSchema(item.fields.image, item.fields.title, item.fields.content),
                                    item.fields.image &&
                                        React.createElement(Item, { original: item.fields.image, thumbnail: item.fields.image, caption: ReactDOMServer.renderToStaticMarkup(getCaptionText(item)), width: getQueryStringParameter(item.fields.image, 'width') || 1100, height: getQueryStringParameter(item.fields.image, 'height') || 1030 }, function (_a) {
                                            var ref = _a.ref, open = _a.open;
                                            return (React.createElement("img", { onClick: open, ref: ref, src: item.fields.image, className: "rounded rounded-5 w-100 h-auto", alt: item.fields.image_description ? item.fields.image_description : "", itemProp: "image" }));
                                        }),
                                    item.fields.title &&
                                        React.createElement("h3", { className: "h2 title-image", itemProp: "name" }, item.fields.title),
                                    React.createElement("div", { className: "splide-card-body d-flex align-items-end" },
                                        React.createElement("div", { className: "splide-card-text flex-grow-1", dangerouslySetInnerHTML: { __html: item.fields.content }, itemProp: "description" })))));
                        }))))))));
}
